const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MESSAGE_MAX_LENGTH = 300;

export function validateContactForm({ email, subject, message }) {
  const errors = {};
  const trimmedEmail = email.trim();
  const trimmedSubject = subject.trim();
  const trimmedMessage = message.trim();

  if (!trimmedEmail) {
    errors.email = 'Email is required.';
  } else if (!EMAIL_RE.test(trimmedEmail)) {
    errors.email = 'Enter a valid email address.';
  }

  if (!trimmedSubject) {
    errors.subject = 'Subject is required.';
  } else if (trimmedSubject.length < 2) {
    errors.subject = 'Subject must be at least 2 characters.';
  }

  if (!trimmedMessage) {
    errors.message = 'Message is required.';
  } else if (trimmedMessage.length < 10) {
    errors.message = 'Message must be at least 10 characters.';
  } else if (trimmedMessage.length > MESSAGE_MAX_LENGTH) {
    errors.message = `Message must be ${MESSAGE_MAX_LENGTH} characters or fewer.`;
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    values: {
      email: trimmedEmail,
      subject: trimmedSubject,
      message: trimmedMessage,
    },
  };
}
